import React, { useEffect, useState } from 'react'
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api'
import { TextFinder } from '../../../components/TextFinder'
import { CardEvent } from '../../../components/Events/CardEvent'
import { ArtistCard } from '../../../components/Events/ArtistCard'
import { SpotifyArtistCard } from '../../../components/Events/SpotifyArtistCard'
import { eventService } from '../../../services/event.service'
import { artistService } from '../../../services/artist.service'
import { useAuth } from '../../../hooks/useAuth'
import { NothingToShow } from '../../../components/Dashboard/NothingToShow'
import { CategoryIcon } from '../../../components/CategoryIcon' // Lo agregué
import { StateDropdown } from '../../../components/StateDropdown' // Lo agregué
import { DatePicker } from '../../../components/DatePicker' // Lo agregué
import { PricePicker } from '../../../components/PricePicker' // Lo agregué
import { Link } from 'react-router-dom'
import SpotifyWebApi from 'spotify-web-api-node'
import './style.scss'
import { Helmet } from 'react-helmet-async'

export const EventDiscoverPage = ({ isAdmin }) => {
  const [token, setToken] = useState('')
  const [events, setEvents] = useState([])
  const [newevents, setnewEvents] = useState([])
  const [savedevents, setsavedEvents] = useState([])
  const [yourevents, setyourEvents] = useState([])
  const [onlyevents, setonlyEvents] = useState([])
  const [artists, setArtists] = useState([])
  const [yourartists, setyourArtists] = useState([])
  const [isRejected, setIsRejected] = useState(false)
  const [categorySelected, setCategorySelected] = useState(null)
  const [categoryName, setCategoryName] = useState(null)
  const [stateSelected, setStateSelected] = useState(null) // Lo agregué
  const [DateSelected, setDateSelected] = useState(null)
  const [stateName, setStateName] = useState(null) // Lo agregué
  const [monthFromSelected, setMonthFromSelected] = useState(null) // Lo agregué
  const [PricetoFind, setPriceToFind] = useState(null)
  const [monthFromName, setMonthFromName] = useState(null) // Lo agregué
  const [monthToSelected, setMonthToSelected] = useState(null) // Lo agregué
  const [monthToName, setMonthToName] = useState(null) // Lo agregué
  const [textToFind, setTextToFind] = useState(null)
  const [isShown, setIsShown] = useState('lista') // Lo agregué
  const [activeMarker, setActiveMarker] = useState(null)
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  })
  const [center, setCenter] = useState({ lat: 20.540732014384595, lng: -100.469693918325 })
  const clientId = 'cd9386b900504ecc853dade2a3fef657'
  const secretId = '38a8fbe6cf384f60a6de96360418e113'
  const redirectURL = 'http://localhost:3000'
  const redirectURLPROD = 'https://raarr.vercel.app'
  const authEndPoint = 'https://accounts.spotify.com/authorize'
  const responseType = 'token'
  const spotifyApi = new SpotifyWebApi({
    clientId: clientId,
    clientSecret: secretId,
    redirectUri: 'https://raarr.vercel.app'
  })

  // hooks
  const { user } = useAuth()
  // Efectos
  useEffect(() => {
    const hash = window.location.hash
    let token = window.localStorage.getItem('token')
    if (hash) {
      token = hash.substring(1).split('&').find(elem => elem.startsWith('access_token')).split('=')[1]
      window.location.hash = ''
      window.localStorage.setItem('token', token)
    }
    setToken(token)
    spotifyApi.setAccessToken(token)
    // console.log(token)
    const getArtists = async () => {
      try {
        const dbArtists = await artistService.getAllArtists()
        setArtists(dbArtists)
      } catch (error) {
        console.log(error)
        setArtists(null)
      }
    }
    getArtists()
    const getyourArtists = async () => {
      try {
        const data = await spotifyApi.getFollowedArtists({ limit: 6 })
        // console.log(data.body.artists.items[0])
        const dataUsed = []
        for (let i = 0; i < data.body.artists.items.length; i++) {
          const buffer = { nombre: data.body.artists.items[i].name, foto: data.body.artists.items[i].images[0].url, link: data.body.artists.items[i].external_urls.spotify, id: i }
          dataUsed.push(buffer)
        }
        setyourArtists(dataUsed)
      } catch (error) {
        console.log(error)
      }
    }
    if (token) {
      getyourArtists()
    }
    const getEvents = async () => {
      // const filterState = !parseInt(stateSelected) ? 0 : parseInt(stateSelected)
      // const filterCategory = !parseInt(categorySelected) ? 0 : parseInt(categorySelected)
      // const filterMonthFrom = (!monthFromSelected || (monthFromSelected.includes(' '))) ? 0 : monthFromSelected
      // const filterMonthTo = (!monthToSelected || (monthToSelected.includes(' '))) ? 0 : monthToSelected
      // const filterTextToFind = !textToFind ? 0 : textToFind
      try {
        // const dbEvents = await eventService.getEventsByFilters(filterState, filterCategory, filterMonthFrom, filterMonthTo, filterTextToFind)
        const dbEvents = await eventService.getAllEvents()
        setEvents(dbEvents)
        // console.log(dbEvents)
      } catch (error) {
        console.log(error)
      }
    }
    getEvents()
    const getnewEvents = async () => {
      setnewEvents([
        { nombre: 'Nuevo 1', foto_portada: 'https://res.cloudinary.com/atemporal/image/upload/v1667693844/dev_setups/images_3_aqivfx.jpg' },
        { nombre: 'Nuevo 2', foto_portada: 'https://res.cloudinary.com/atemporal/image/upload/v1667703351/dev_setups/Captura_de_Pantalla_2022-11-05_a_la_s_8.55.02_p.m._q6gwkp.png' },
        { nombre: 'Nuevo 3', foto_portada: 'https://res.cloudinary.com/atemporal/image/upload/v1667703359/dev_setups/Captura_de_Pantalla_2022-11-05_a_la_s_8.54.51_p.m._hhmj5x.png' },
        { nombre: 'Nuevo 4', foto_portada: 'https://res.cloudinary.com/atemporal/image/upload/v1667693597/dev_setups/yves-klein-azul_of6efp.jpg' }
      ])
    }
    getnewEvents()
    const getsavedEvents = async () => {
      setsavedEvents([
        { nombre: 'Saved 1', foto_portada: 'https://www.colorbook.io/imagecreator.php?hex=6366f1&width=1080&height=1920&text=%201080x1920' },
        { nombre: 'Saved 2', foto_portada: 'https://www.colorbook.io/imagecreator.php?hex=6366f1&width=1080&height=1920&text=%201080x1920' },
        { nombre: 'Saved 3', foto_portada: 'https://www.colorbook.io/imagecreator.php?hex=6366f1&width=1080&height=1920&text=%201080x1920' }
      ])
    }
    getsavedEvents()
    const getyourEvents = async () => {
      setyourEvents([
        { nombre: 'Lucrecia Dalt en Querétaro', foto_portada: 'https://f4.bcbits.com/img/0028634901_10.jpg' },
        { nombre: 'Tu evento 2', foto_portada: 'https://www.colorbook.io/imagecreator.php?hex=6366f1&width=1080&height=1920&text=%201080x1920', link: 'https://open.spotify.com/artist/0btHg0Byq8j9jqp8iwIqyQ', id: 2 },
        { nombre: 'ChupameElDedo en CDMX', foto_portada: 'https://i.ytimg.com/vi/KaLE6C1Z23Y/maxresdefault.jpg' },
        { nombre: 'Tu evento 4', foto_portada: 'https://www.colorbook.io/imagecreator.php?hex=6366f1&width=1080&height=1920&text=%201080x1920', link: 'https://open.spotify.com/artist/1TWdamQsAiOgB0szQsMSeq', id: 4 }
      ])
    }
    getyourEvents()
    const getonlyEvents = async () => {
      setonlyEvents([
        { nombre: 'Frente Cumbiero en Querétaro', foto_portada: 'https://media.vozpopuli.com/2021/02/Frente-Cumbiero-crema-musical-tropico_1265883404_13664344_1020x574.jpg' },
        { nombre: 'Los Pirañas en Querétaro', foto_portada: 'https://www.galletascalientes.com/wp-content/uploads/2014/05/Los-Piranas-videoclip-resized.jpg' },
        { nombre: 'Ondatropica en Querétaro', foto_portada: 'https://static-uat.cambiocolombia.com/inline-images/mimo_group_ondatropica_2017_septeto.jpg' },
        { nombre: 'Romperayo en Querétaro', foto_portada: 'https://i.scdn.co/image/ab6761610000e5eb387c52598124ac8b3f562d95' }
      ])
    }
    getonlyEvents()
  }, [stateSelected, monthFromSelected, monthToSelected, categorySelected, isRejected, textToFind, PricetoFind])
  const handlerOnSubmit = (event) => {
    event.target.preventDefault()
  }
  const handleClick = () => {
    if (isShown === 'mapa') {
      setIsShown('lista')
    }
    if (isShown === 'lista') {
      setIsShown('mapa')
      const getUserLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            setCenter({ lat: position.coords.latitude, lng: position.coords.longitude })
          })
        } else {
          console.log('Geolocation is not supported by this browser.')
        }
      }
      getUserLocation()
    }
  }
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return
    }
    setActiveMarker(marker)
  }

  let notFoundMessage = textToFind || ''
  if (!notFoundMessage) {
    notFoundMessage += categoryName || ''
    notFoundMessage += notFoundMessage ? (stateName !== null ? ` en ${stateName}` : '') : (stateName || '')
    if (monthFromSelected && monthToSelected && (monthFromSelected !== 'Invalid date') && (monthToSelected !== 'Invalid date')) {
      notFoundMessage += ` fecha:  ${monthFromSelected}`
    }
  }
  if (!isLoaded) return <></> // Lo agregué para que no se cargue el mapa hasta que se cargue el script
  const today = new Date()
  return (
    <>
    <div>
      <Helmet>
          { /* Standard metadata tags */ }
          <title>RAARR | Home</title>
          <meta name='description' content='RAARR | Home' />
      </Helmet>
    </div>
        {/* Page content */}
        <section className="container mt-1 mb-lg-5 pt-lg-2 pb-5 event-discover white-text">
          {/* Page title + Layout switcher + Search form */}
          {/* <div className="row align-items-end gy-3 mb-4 pb-lg-3 pb-1">
            <div className="col-lg-8 col-md-7">
              <form className="row gy-2 d-flex justify-content-end" onSubmit={handlerOnSubmit}>
                <StateDropdown setStateSelected={setStateSelected} setStateName={setStateName}/>
                <DatePickerFrom setMonthFromSelected={setMonthFromSelected} setMonthFromName={setMonthFromName} setMonthToSelected={setMonthToSelected} setMonthToName={setMonthToName}/>
                <TextFinder setTextToFind={setTextToFind} />
              </form>
            </div>
            <div className="scroll mb-n4">
            <CategoryIcon categorySelected={categorySelected} setCategorySelected={setCategorySelected} setCategoryName={setCategoryName} />
            </div>
          </div> */}
          {/* Blog grid */}
          <div className="row">
          {/* ALL EVENTS  */}
          <div className="pb-4 align-items-center d-flex">
          <h2 className="mb-2 mb-md-0 inline-display">
            Eventos
          </h2>
          <div className="justify-content-center inline-display px-4">
            <button type="button" className="btn btn button btn-sm fs-sm rounded px-2"
            onClick={handleClick} >
            {isShown === 'lista'
              ? <><span className="px-1">Ver en el mapa</span><i className="bx bx-map bx-sm px-1" /></>
              : <><span className="px-1">Mostrar lista</span><i className="bx bx-list-ul bx-sm px-1" /></>
            }
            </button>
          </div>
          </div>
          {
              isShown === 'lista' && (
                events.slice(0, 12).map((event, index) => (

                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                ))
              )
            }
            {
            isShown === 'mapa' && (
            <GoogleMap
            options= { { mapId: '73ae4e74dbf7fb53' } }
            zoom={13}
            center={center}
            mapContainerClassName="map-container"
            onClick={() => setActiveMarker(null)}
            >
            <Marker
            key = {'user-key-10'}
            position = {center}
            icon={{
              path: // User location icon without google maps
                'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
              fillColor: '#1E90FF',
              borderColor: '#00BFFF',
              fillOpacity: 1,
              strokeWeight: 0,
              scale: 2.1
            }}
            />
            {events.map((event, index) => (
            <Marker
            key={index} // Para que se muestren los marcadores el key tiene que ser dinámico
            position={{ lat: parseFloat(event.latitud), lng: parseFloat(event.longitud) }}
            onClick={() => handleActiveMarker(event.nombre)}
            animation={2}
            >
            {activeMarker === event.nombre
              ? (
              <InfoWindow
              onCloseClick={() => setActiveMarker(null)}
              options={{ maxWidth: 320 }}
              >
                <>
                  <Link className='link' to={`/eventos/${event.eid}`}>
                    <div className='img-container'>
                      <img className="infoimg" src={event.foto_portada}/>
                    </div>
                    <div className = 'text-container'>
                      <h2 className='pt-1 text-black'>{event.nombre}</h2>
                      <h3 className='pt-2 text-black'>{event.ubicacion}</h3>
                    </div>
                  </Link>
                </>
              </InfoWindow>
                )
              : null}
            </Marker>
            ))}
          </GoogleMap>
            )}
          </div>
        {/* Pagination */}
          <h2 className="pt-4 mb-2 mb-md-0">
            Tus artistas
          </h2>
          <h6 className="pb-4 pb-3 mb-2 mb-md-0">
            Artistas que sigues y escuchas.
          </h6>
          <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                yourartists.slice(0, 6).map((artist, index) => (
                <div className="col-6 col-md-4 col-xl-2"
                key={index}
                >
                  <SpotifyArtistCard
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...artist}
                  />
                </div>
                ))
              }
            </div>

          <a href={`${authEndPoint}?client_id=${clientId}&scope=user-follow-read&redirect_uri=${redirectURLPROD}&response_type=${responseType}`}>
          <h6 className="mb-2 mb-md-0 text-primary">
            Escanea tu biblioteca musical
          </h6>
          </a>
          <h6 className="">
            Mantente informado de cuando tus artista favorito organiza un concierto
          </h6>
          <h2 className="pt-4 mb-2 mb-md-0">
            Nuevos eventos
          </h2>
          <h6 className="pb-4 pb-3 mb-2 mb-md-0">
            Recién anunciados. Actualizado cada Jueves.
          </h6>
          {/* <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                newevents.slice(0, 4).map((event, index) => (
                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                ))
              }
            </div> */}
              {/* <h1 className="pb-4 mb-2 mb-md-0">
                Saved
              </h1> */}
              {/* <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                savedevents.slice(0, 3).map((event, index) => (
                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                ))
              }
              </div> */}
              <h1 className="pb-4 mb-2 mb-md-0">
                Sólo para ti
              </h1>
              {/* <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                yourevents.slice(0, 4).map((event, index) => (
                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                ))
              }
              </div> */}
              <h1 className="pb-4 mb-2 mb-md-0">
                Únicamente en RAARR
              </h1>
            {/* <div className="row d-flex flex-row flex-nowrap overflow-auto">
              {
                onlyevents.slice(0, 4).map((event, index) => (
                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardEvent
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...event}
                  />
                </div>
                ))
              }
            </div> */}
              <h1 className="pb-4 mb-2">
                Artistas populares
              </h1>
            <div className="row d-flex flex-row flex-nowrap overflow-auto mb-3">
              {
                artists.slice(0, 6).map((artist, index) => (
                <div className="col-6 col-md-4 col-xl-2"
                key={index}
                >
                  <ArtistCard
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...artist}
                  />
                </div>
                ))
              }
            </div>
        </section>
    </>
  )
}
